<div class="static-content-page">
  <div class="container">
    <div class="row justify-content-center">
      <div class="col-lg-10 col-xl-8">
        
        <!-- Loading State -->
        <div *ngIf="loading" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
          <p class="mt-3 text-muted">Loading content...</p>
        </div>

        <!-- Error State -->
        <div *ngIf="error && !loading" class="alert alert-danger" role="alert">
          <i class="fas fa-exclamation-triangle me-2"></i>
          {{ error }}
        </div>

        <!-- Content Display -->
        <div *ngIf="content && !loading && !error" class="content-wrapper">
          <div class="page-header mb-4">
            <h1 class="page-title">{{ getPageTitle() }}</h1>
          </div>

          <div class="content-body">
            <div [innerHTML]="content.content" class="content-html"></div>
          </div>
        </div>

        <!-- Back Navigation -->
        <div class="mt-5 text-center">
          <button type="button" class="btn btn-outline-primary" (click)="goBack()">
            <i class="fas fa-arrow-left me-2"></i>
            Go Back
          </button>
        </div>

      </div>
    </div>
  </div>
</div>
